import {
  FaGlobeAmericas,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGithub,
  FaDribbble,
  FaInstagram,
  FaStackOverflow,
  FaBehance,
  FaGitlab,
  FaBirthdayCake,
  FaTelegram,
  FaSkype,
} from 'react-icons/fa';
import { MdPhone, MdEmail } from 'react-icons/md';

const Icons = {
  phone: MdPhone,
  website: FaGlobeAmericas,
  email: MdEmail,
  facebook: FaFacebookF,
  twitter: FaTwitter,
  linkedin: FaLinkedinIn,
  github: FaGithub,
  dribbble: FaDribbble,
  instagram: FaInstagram,
  stackoverflow: FaStackOverflow,
  behance: FaBehance,
  gitlab: FaGitlab,
  birthday: FaBirthdayCake,
  telegram: FaTelegram,
  skype: FaSkype,
};

export default Icons;
